







import { Component, Vue } from "vue-property-decorator";
import ZhCn from "./components/zhCn.vue";
import ZhHk from "./components/zhHk.vue";
@Component({
  components: {
    zhCn: ZhCn,
    zhHk: ZhHk
  }
})
export default class CustomerAgreement extends Vue {
  langValue = "";
  created() {
    this.langValue = localStorage.getItem("localLang") || "en";
    
  }
}
